import { Navigation } from '../Shared/navigation';

export default class ModalDialog {
	constructor() {
		const $modalLayout = $('#modal-dialog-layout');

		$('*[data-modal-dialog="true"]').each(function (i, el) {
			const $el = $(el);
			const title = $el.data('modal-dialog-title');

			$el.click((e) => {
				e.preventDefault();

				const href = $(e.currentTarget).attr('href');

				$.get(href, function (data) {
					$modalLayout.find('.modal-body').empty().html(data);
					$modalLayout.find('.modal-title').text(title);
					$modalLayout.modal({ focus: false });
				});
			});
		});

		$modalLayout.on('show.bs.modal', () => {
			let $form = $modalLayout.find('form');

			if ($form) {
				const onFormSubmit = (e: any) => {
					e.preventDefault();

					$.ajax({
						url: $form.attr('action'),
						type: "POST",
						data: $(e.currentTarget).serialize(),
						success: function (data) {
							Navigation.reload();
						},
						error: function (response) {
							$modalLayout.find('.modal-body').empty().html(response.responseText);

							$form = $modalLayout.find('form');
							if ($form) {
								$form.on('submit', onFormSubmit);

								const $submitButton = $modalLayout.find('button[type="submit"]');
								$submitButton.unbind('click');
								$submitButton.click((e) => {
									e.preventDefault();
									$form.submit();
								});
							}
						}
					});
				};

				$form.on('submit', onFormSubmit);

				$modalLayout.find('button[type="submit"]').click((e) => {
					e.preventDefault();
					$form.submit();
				});
			}
		});

		$modalLayout.on('hidden.bs.modal', function (e) {
			$modalLayout.find('.modal-body').empty();
			$modalLayout.find('.modal-title').text('');
			$modalLayout.find('form').unbind('submit');
			$modalLayout.find('button[type="submit"]').unbind('click');
		});
	}
}
